import utcToZonedTime from 'date-fns-tz/utcToZonedTime';
import addDays from 'date-fns/addDays';
import type { IntlShape } from 'react-intl-next';

import { WEEK_DAY_COUNT } from './constants';

const generateMonthColumns = ({
	startEpoch,
	intlApi,
	offset,
}: {
	startEpoch: number;
	intlApi: IntlShape;
	offset: number;
}) => {
	const start = utcToZonedTime(startEpoch + offset, 'UTC');

	return [...Array(WEEK_DAY_COUNT)].map((_, index) =>
		intlApi.formatDate(addDays(start, index), {
			weekday: 'long',
		}),
	);
};

export { generateMonthColumns };
